export default __webpack_public_path__ + "static/media/team118.05ea8da0.JPG";